import { COUNTRIES } from './utils/countries.js';

export const BACKEND_API_URL =
  import.meta.env.VITE_BACKEND_API_URL || `http://localhost:8000`;

// Google OAuth Web client ID (Sign in/up with Google).  Placeholder values
// keep the buttons rendering a friendly "not configured" error - see
// sortmyprep-backend/docs/google-oauth-setup.md.
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';
export const isGoogleAuthConfigured = () =>
  Boolean(GOOGLE_CLIENT_ID) &&
  !GOOGLE_CLIENT_ID.toLowerCase().includes('placeholder');

export const storageKeys = {
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
};

export const passwordValidations = [
  'Your password must contain at least 8 characters.',
  'Your password can’t be a commonly used password.',
  'Your password can’t be entirely numeric.',
];

export const stateChoices = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
  'Andaman and Nicobar Islands',
  'Chandigarh',
  'Dadra and Nagar Haveli and Daman and Diu',
  'Lakshadweep',
  'Delhi',
  'Puducherry',
  'Ladakh',
];

export const SCHOOLS = [
  '10 X International School',
  'Aarth Universal School',
  'Adani International School',
  'Aditya Birla World Academy',
  'Ahmedabad International School',
  'Ajmera Global School',
  'Akal Academy Baru Sahib',
  'Akshar Árbol International School',
  'Akshar Arbol International School - ECR',
  'Alphabet international school',
  'American Embassy School',
  'American International School-Chennai',
  'American School of Bombay',
  'Amity Global School',
  'Amity Global School, Noida',
  'Amrita International Vidyalayam',
  'Apeejay School International, South Delhi',
  'Ascend International School',
  'Aspee Nutan Academy',
  'B.D. Somani International School',
  'Bangalore International School',
  'BGS International Academia School',
  "Bihani Children's Academy",
  'Birla Open Minds International School',
  'BLISS International School',
  'Bloomingdale International School',
  'Bodhi International School',
  'Bombay International School',
  'Bunts Sanghas S M Shetty Intl School and Junior College',
  'C P Goenka International School (Pune)',
  'C.P Goenka International School, Oshiwara',
  'Calcutta International School Society',
  'Calorx Olive International School',
  'Cambridge International Foundation School',
  'Canadian International School',
  'CANARY THE SCHOOL',
  'Candor International School',
  'Chaman Bhartiya School',
  'CHATRABHUJ NARSEE SCHOOL',
  "Children's Academy International School",
  'Chinmaya International Residential School',
  'Chinmaya International Vidyalaya',
  'CHIREC International',
  'Choithram International',
  'Christ Junior College',
  'Christ Junior College - Residential',
  'Cochin International School',
  'CPS GLOBAL SCHOOL Annanagar',
  'CPS Global School, Thirumazhisai',
  'Crossroads International School',
  'Cygnus International School',
  'D Y Patil International School',
  'D Y Patil International School, Nerul',
  'Delhi Public School, Bangalore East',
  'Delhi Public School Bangalore North',
  'Delhi Public School Ghaziabad',
  'Delhi Public School Ghaziabad Vasundhara',
  'Dhirubhai Ambani International School',
  'Don Bosco International School',
  'DPS International',
  'DPSG International',
  'DPSG Palam Vihar',
  'Dr. Pillai Global Academy',
  'Dr. Pillai Global Academy, New Panvel',
  'DRS International School',
  'DSB International School',
  'Eastern Public School',
  'Ebenezer International School Bangalore',
  'Ecole Mondiale World School',
  'Edubridge International School',
  'Ela Green School',
  'Elpro International School',
  'Excelsior American School',
  "Fazlani L'Académie Globale",
  'Finland International School - Thane',
  'Finland International School Race Course',
  'Firststeps School',
  'Focus High School',
  'Fountainhead School',
  'G D GOENKA GLOBAL SCHOOL',
  'G Global School',
  'GAET International School- Aldeia',
  'Garodia International Centre for Learning Mumbai',
  'Gateway International School',
  'GD Goenka World School',
  'Gems Modern Academy, Kochi',
  'Genesis Global School',
  'GJR International School',
  'Glendale Academy',
  'Glendale International School',
  'Goldcrest International',
  'Good Shepherd International School',
  'GPS Brookes Kochi',
  'Greenwood High',
  'Harrow International School Bengaluru',
  'Harvest International School',
  'Heartfulness International School, Omega Branch',
  'HERITAGE INTL XPERIENTIAL SCHOOL',
  'HFS International',
  'Hill Spring International School',
  'Hiranandani Upscale School (HUS)',
  'IIS World School (A Unit of Indian Council For International Amity)',
  'INDIA KIDS SCHOOL',
  'Indus International Primary (Early Years) School',
  'Indus International School Pune',
  'Indus International School, Bangalore',
  'Indus International School, Hyderabad',
  'INTERNATIONAL FATEH ACADEMY',
  'International School of Hyderabad',
  'International Village School Chennai',
  'Invictus International School',
  'Jain International Residential School',
  'Jain Vidyalaya',
  'Jamnabai Narsee International School',
  'Jayshree Periwal International School',
  'JBCN International School, Chembur',
  'JBCN International School, Oshiwara',
  'JBCN International School, Parel',
  'JG International School',
  'Johnson Grammar School IBDP',
  'Johnson Grammar School Kokapet',
  'K.R. MANGALAM GLOBAL SCHOOL',
  'Kai Early Years',
  'KAMALA NIKETAN INTERNATIONAL SCHOOL',
  'Kanakia International School',
  'KC High',
  'Keystone School',
  'KiiT International School',
  'KNOWLEDGEUM ACADEMY, JAYANAGAR',
  'Kodaikanal International School',
  'Kothari International School, Noida',
  'Krishna Vikash Global School',
  'Kunskapsskolan Gurgaon',
  'Lady Andal School',
  'Lancers International School',
  'Learners International School',
  'Legacy School',
  'Lucent Global School',
  'M.Ct.M.Chidambaram Chettyar International School',
  'Mahatma Gandhi International School',
  'Mahindra International School',
  'Mahindra United World College',
  'Manav Rachna International School',
  'Manchester Global School',
  'Manchester International School - Coimbatore',
  'Meluha International School',
  'Meridian School',
  'Meridian School For Boys and Girls',
  'Modern High School International',
  'Modern Public School',
  'Modern School',
  'Mount Abu Public School',
  'Mount Litera School International',
  'MRS Educational Trust (Redbridge international Academy)',
  'Mussoorie International School',
  'Nahar International School',
  'Navrachana International School, Vadodara',
  'Neerja Modi School',
  'Neev Academy',
  'NES International School Mumbai',
  'NEXT School',
  'Nita Mukesh Ambani Junior School',
  'Oakridge International School (multiple campuses)',
  'Oberoi International School',
  'One World International School Sarjapur',
  'One World International School Whitefield',
  'Orange Educational Society, C/O Oakridge International School, Bangalore',
  'Pathways School Gurgaon',
  'Pathways School Noida',
  'Pathways World School, Gurgaon',
  'Podar International School',
  'Podar ORT International School, Worli',
  'Prometheus School',
  'Radcliffe School',
  'Rockwell International School',
  'RP Goenka International School',
  'Ruh Continuum School',
  'Ryan Global School',
  'Ryan Global School Kharghar',
  'Sai International School',
  'SANATAN HIGH SCHOOL',
  'Sancta Maria International School (Faridabad)',
  'Sanjay Ghodawat International School',
  'Sanjay Ghodawat International School, Mulshi, Pune',
  'Sanskar School',
  'SARALA BIRLA ACADEMY',
  'Satya School',
  'Scottish High International School',
  'SHAMBHU DAYAL GLOBAL SCHOOL',
  'Shantiniketan International School',
  'Sharanya Narayani International School',
  'Shiv Nadar School Faridabad',
  'SHIV NADAR SCHOOL GURUGRAM',
  'Shiv Nadar School Noida',
  'Silver Oaks International School, Visakhapatnam',
  'Silver Oaks International School, Hyderabad',
  'Silver Oaks International School, Oakwinds Campus',
  'Singapore International School',
  'SKILL STORK INTERNATIONAL SCHOOL',
  'Smt. Sulochanadevi Singhania School (IBDP)',
  'Sreenidhi International School',
  "St. Mary's School, Pune",
  'Stellar World School',
  'Step by Step School',
  'Stonehill International School',
  'Strawberry Fields High School',
  'Suncity School',
  'Sunshine Worldwide School',
  "SVB's International School Dombivli",
  'SVKM J V PAREKH INTERNATIONAL SCHOOL',
  'Symbiosis International School',
  'TCIS',
  'The Aga Khan Academy Hyderabad',
  "The Bombay Suburban Grain Dealers' Junior College of Commerce, Arts and Science",
  'The British School New Delhi',
  'The Cathedral and John Connon School',
  'THE CHOICE SCHOOL.',
  'The Doon School',
  'The Galaxy School',
  'The Gaudium School',
  'The Heritage School',
  'The Indian Public School - Chennai',
  'The Indian Public School - Coimbatore',
  'The Indian Public School - Erode International',
  'The Indian Public School - Kochi',
  'The Indian Public School - Salem',
  'The Indian Public School - Trichy',
  'The International School Bangalore',
  'The NEST School',
  'The Pupil',
  'THE SCHOOL OF RAYA',
  'The Seekers International',
  'The Shri Ram Academy',
  'The Shri Ram School',
  'The Shriram Millennium School, Noida',
  'The Universal School',
  'The White School International',
  'Treamis International School',
  'TRIO World Academy',
  'Trivandrum International School',
  'Udgam School for Children',
  'UNICOSMOS',
  'Utpal Shanghvi Global School',
  'Vedanya',
  'Velammal Global School, Madurai',
  'Victorious Kidss Educares',
  'Vidya Global School, Bagpat Road, Meerut',
  'VIRAJ INTERNATIONAL SCHOOL',
  'Vishwashanti Gurukul',
  'Vista International School',
  'VIVA The School',
  'Wellington College International Pune',
  'Wockhardt Global School',
  'Woodstock School',
  'ACS Cobham International School',
  'ACS Egham International School',
  'ACS Hillingdon International School',
  'American School',
  "Bedford Girls' School",
  'Berkhamsted School',
  "Bishop Wordsworth's School",
  'Bradfield College',
  'Bromsgrove School',
  'Cardiff Sixth Form College',
  'Caterham School',
  "Cheltenham Ladies' College",
  'City of London School',
  'Clifton College',
  'Cobham Hall',
  'Dartford Grammar School',
  'Dartford Grammar School for Girls',
  'Dulwich College',
  'Ellesmere College',
  'Emanuel School',
  'Exeter School',
  'Felsted School',
  'Fettes College',
  "George Watson's College",
  'Giggleswick School',
  'Gordonstoun',
  'Haileybury',
  'Harrow School',
  'Hills Road Sixth Form College',
  'Hurstpierpoint College',
  'Impington Village College',
  'International School of Aberdeen',
  "King Edward's School, Birmingham",
  'King Edward VI High School',
  "King's College School, Wimbledon",
  "King's Ely",
  'Kingswood School',
  'Latymer Upper School',
  'Leighton Park School',
  'Malvern College',
  'Manchester Grammar School',
  'Marymount International School London',
  "Merchant Taylors' School",
  'Millfield School',
  'Monkton Combe School',
  'Norwich School',
  'Oakham School',
  'Old Palace of John Whitgift School',
  'Oxford International College',
  'Perse School',
  'Portsmouth Grammar School',
  'Putney High School',
  "Queen Anne's School",
  "Queen Ethelburga's Collegiate",
  "Reed's School",
  'Rendcomb College',
  'Royal Grammar School, Guildford',
  'Royal Grammar School, Newcastle',
  'Royal High School Bath',
  'Sevenoaks School',
  'Shrewsbury School',
  'Southbank International School',
  "St Clare's, Oxford",
  "St Edward's School, Oxford",
  'St Leonards School',
  "St Paul's School",
  "St Swithun's School",
  'Stonyhurst College',
  "Stratford Girls' Grammar School",
  'Sutton Valence School',
  'Taunton School',
  'The Abbey School Reading',
  'The City Academy, Hackney',
  'The Edinburgh Academy',
  'The Grange School',
  "The King's School, Canterbury",
  "The King's School, Macclesfield",
  "The King's School, Worcester",
  'The Leys School',
  'The Manchester Grammar School',
  'The Marist School',
  'The Royal School, Wolverhampton',
  'The Stephen Perse Foundation',
  'The Thomas Hardye School',
  "The Windsor Boys' School",
  'Tonbridge School',
  'Trent College',
  'Truro School',
  'UWC Atlantic College',
  'UWC Scotland',
  'Wellington College',
  'Westminster School',
  'Whitgift School',
  'Wimbledon High School',
  'Woodhouse Grove School',
  'Worth School',
  'GEMS World Academy – Dubai',
  'Dubai American Academy',
  'Dubai International Academy',
  'Repton School Dubai',
  'Raffles World Academy',
  'Jumeirah Baccalaureate School',
  'Jumeirah English Speaking School',
  'Emirates International School',
  'GEMS Modern Academy',
  'GEMS Wellington International School',
  'GEMS Wellington Academy – Silicon Oasis',
  'Greenfield International School',
  'Uptown International School',
  'Nord Anglia International School Dubai',
  'Swiss International Scientific School in Dubai',
  'Brighton College Dubai',
  'Deira International School',
  'Horizon International School',
  'Ambassador International Academy',
  'Dubai College',
  'Dubai British School',
  'Jumeirah College',
  'Dubai English Speaking College',
  'Arcadia Global School',
  'GEMS New Millennium School',
  'Cambridge International School',
  'Dubai Scholars Private School',
  'Safa Community School',
  'Sunmarke School',
  'One World International School',
  'Clarion School',
  'Kent College Dubai',
  'North London Collegiate School Dubai',
  'Australian International School Singapore',
  'Canadian International School Singapore',
  'Chatsworth International School',
  'Dover Court International School',
  'Hwa Chong International School',
  'ISS International School',
  'Nexus International School Singapore',
  'North London Collegiate School Singapore',
  'SJI International School',
  'Stamford American International School',
  'Tanglin Trust School',
  'United World College of South East Asia',
  'Global Indian International School Singapore',
  'EtonHouse International School Singapore',
  'Middleton International School',
  'Westbourne College Singapore',
  'Agoura High School',
  'Atlanta International School',
  'British International School of Houston',
  'Carrollwood Day School',
  'Dallas International School',
  'Dwight School',
  'EF Academy New York',
  'Granada Hills Charter High School',
  'International School of Los Angeles',
  'Léman Manhattan Preparatory School',
  'Lubbock High School',
  'Mira Loma High School',
  'North Broward Preparatory School',
  'Quarry Lane School',
  'San Diego High School of International Studies',
  'St. Petersburg High School',
  'Stanton College Preparatory School',
  'United Nations International School',
  'Washington International School',
  'Westlake Academy',
];

export function getSchoolOptions() {
  return SCHOOLS.map((s) => ({ label: s, value: s }));
}

// Compact `{ label, value }` options for the phone-code dropdowns on the profile,
// organisation enrollment and classroom screens. Derived from COUNTRIES rather
// than hand-written so those screens stay in step with the canonical list.
//
// The value is the dial code, which is not unique across countries - a `+44`
// selection cannot be told apart from Guernsey, Jersey or the Isle of Man on
// read-back. New consumers should key on `iso2` and build their own options.
export const countryCodeOptions = COUNTRIES.map((c) => ({
  label: `${c.flag} ${c.dial}`,
  value: c.dial,
}));

export const teacherLandingSocialLinks = [
  {
    name: 'WhatsApp',
    href: 'https://chat.whatsapp.com/LueinbivpdG5SUKEpGYxlc?mode=ac_t',
    svg: '<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>',
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/sortmyprep/',
    svg: '<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>',
  },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/@SortMyPrep',
    svg: '<path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>',
  },
  {
    name: 'TikTok',
    href: 'https://www.tiktok.com/@sortmyprep',
    svg: '<path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>',
  },
];
